import styled from 'styled-components';
import FiduciaLogo from '../../../../../../../assets/images/fiducia-logo.jpg';

interface IValues {
  isActive?: boolean;
}

interface IDivisor {
  margin?: string;
}

interface ITableData {
  width?: string;
}

interface ITableRow {
  borderBottom?: string;
}

const header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.125rem solid #909090;
  margin: 0 0 2.5rem 0;
  padding-bottom: 2.5rem;
  height: 6.25rem;
  width: 100%;
`;

const logo = styled.div`
  background-image: url(${FiduciaLogo});
  background-repeat: no-repeat;
  background-size: contain;
  width: 22rem;
  height: 100%;
`;

const mainTitle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: auto;
  height: 100%;
  font-size: 2.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

const title = styled.div`
  font-size: 3rem;
  display: flex;
  font-weight: 700;
  color: #125c5b;
`;

const subtitle = styled.div`
  font-size: 2.5rem;
  color: #606060;
`;

const body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding-top: 2.5rem;
  justify-content: flex-start;
  align-items: center;
`;

const label = styled.p`
  font-size: 2rem;
  font-weight: 500;
  width: 100%;
`;

const values = styled.p<IValues>`
  color: #606060;
  font-weight: 500;
  display: ${(props) => (props.isActive ? 'flex' : 'none')};
  text-align: center;
  font-size: 2.5rem;
  margin: 0.5rem 1.5rem;
`;

const subValues = styled.p`
  color: #404040;
  font-weight: 500;
  font-size: 1.5rem;
`;

const containerLabelValues = styled.div`
  font-size: inherit;
  display: flex;
  flex-direction: column;
  margin: 3.5rem 1.5rem;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const containerLabelValuesRow = styled.div`
  font-size: inherit;
  display: flex;
  flex-direction: column;
  margin: 1rem 1.5rem;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const containerRow = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

const content = styled.div`
  font-size: inherit;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const table = styled.table`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  width: 100%;
`;

const tableHead = styled.thead`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const tableBody = styled.tbody`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const tableRow = styled.tr<ITableRow>`
  display: flex;
  flex-direction: row;
  border-bottom: ${(props) =>
    props.borderBottom ? props.borderBottom : '1px solid #606060'};
  width: 100%;
  justify-content: space-between;
`;

const tableData = styled.td<ITableData>`
  display: block;
  color: #606060;
  font-size: 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  min-width: ${(props) => (props.width ? props.width : '15rem')};
`;

const container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 0.125rem solid #909090;
  margin: 2rem 0;
  align-items: center;
`;

const divisor = styled.div<IDivisor>`
  display: flex;
  width: 100%;
  border-bottom: 0.125rem solid #909090;
  margin: ${(props) => (props.margin ? props.margin : '')};
`;

const page = styled.div`
  @media all {
    .page-break {
      display: none;
    }
  }

  @media print {
    html,
    body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }

  @media print {
    .page-break {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
    }
  }

  @page {
    size: auto;
    margin: 10mm;
  }
`;

const FiduciaPdf = {
  Page: page,
  Header: header,
  Logo: logo,
  MainTitle: mainTitle,
  Title: title,
  Subtitle: subtitle,
  Body: body,
  Label: label,
  Values: values,
  SubValues: subValues,
  ContainerLabelValues: containerLabelValues,
  ContainerLabelValuesRow: containerLabelValuesRow,
  ContainerRow: containerRow,
  Content: content,
  Table: table,
  THead: tableHead,
  TBody: tableBody,
  Tr: tableRow,
  Td: tableData,
  Divisor: divisor,
  Container: container,
};

export default FiduciaPdf;
